'use strict';

var base = require('../product/details');

module.exports = function () {
    base.sizeChartTemplate();
    base.selectVariantAttribute();
    base.selectAttribute();
    base.colorAttribute();
};